import { differenceInCalendarDays, format, formatDistanceToNow, isValid, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

function toDate(value?: string | null): Date | null {
  if (!value) return null
  const d = value.length <= 10 ? parseISO(value + 'T00:00:00') : parseISO(value)
  return isValid(d) ? d : null
}

export function formatDate(value?: string | null, fallback = '—'): string {
  const d = toDate(value)
  return d ? format(d, 'dd/MM/yyyy', { locale: ptBR }) : fallback
}

export function formatDateTime(value?: string | null, fallback = '—'): string {
  const d = toDate(value)
  return d ? format(d, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR }) : fallback
}

export function formatWeekdayShort(value?: string | null): string {
  const d = toDate(value)
  return d ? format(d, 'EEEEEE', { locale: ptBR }) : ''
}

export function formatRelative(value?: string | null, fallback = '—'): string {
  const d = toDate(value)
  return d ? formatDistanceToNow(d, { locale: ptBR, addSuffix: true }) : fallback
}

/** Dias até a data (negativo = atrasado). null se sem data. */
export function daysUntil(value?: string | null): number | null {
  const d = toDate(value)
  if (!d) return null
  return differenceInCalendarDays(d, new Date())
}

export function isOverdue(dueDate?: string | null): boolean {
  const days = daysUntil(dueDate)
  return days !== null && days < 0
}

export function isDueSoon(dueDate?: string | null, within = 3): boolean {
  const days = daysUntil(dueDate)
  return days !== null && days >= 0 && days <= within
}

export function humanFileSize(bytes?: number | null): string {
  if (!bytes || bytes < 0) return '—'
  const units = ['B', 'KB', 'MB', 'GB']
  let value = bytes
  let i = 0
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024
    i++
  }
  return `${value.toFixed(value < 10 && i > 0 ? 1 : 0)} ${units[i]}`
}

/** Valor para <input type="date"> (YYYY-MM-DD) a partir de ISO/date. */
export function toDateInputValue(value?: string | null): string {
  const d = toDate(value)
  return d ? format(d, 'yyyy-MM-dd') : ''
}
